export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SIGNOUT = "SIGNOUT";

export const CREATE_REQUEST = "CREATE_REQUEST";
export const CREATE_SUCCESS = "CREATE_SUCCESS";
export const CREATE_FAILURE = "CREATE_FAILURE";

export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR";

export const GET_ALLPRODUCT_REQUEST = "GET_ALLPRODUCT_REQUEST";
export const GET_ALLPRODUCT_SUCCESS = "GET_ALLPRODUCT_SUCCESS";
export const GET_ALLPRODUCT_ERROR = "GET_ALLPRODUCT_ERROR";

export const GET_SINGLEPRODUCT_REQUEST = "GET_SINGLEPRODUCT_REQUEST";
export const GET_SINGLEPRODUCT_SUCCESS = "GET_SINGLEPRODUCT_SUCCESS";
export const GET_SINGLEPRODUCT_ERROR = "GET_SINGLEPRODUCT_ERROR";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_ERROR = "ADD_PRODUCT_ERROR";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_ERROR = "DELETE_PRODUCT_ERROR";

export const GET_ALLCUSTOMER_REQUEST = "GET_ALLCUSTOMER_REQUEST";
export const GET_ALLCUSTOMER_SUCCESS = "GET_ALLCUSTOMER_SUCCESS";
export const GET_ALLCUSTOMER_ERROR = "GET_ALLCUSTOMER_ERROR";

export const GET_ALLADMINS_REQUEST = "GET_ALLADMINS_REQUEST";
export const GET_ALLADMINS_SUCCESS = "GET_ALLADMINS_SUCCESS";
export const GET_ALLADMINS_ERROR = "GET_ALLADMINS_ERROR";
